import { useOverlayContext, ConfirmationModal } from 'seagull';
import { useStore, useStoreActions } from "../contexts";
import { handlePromise } from "../infra/utils";
import { selectors } from "../store/state-selectors";
import { jsx as _jsx } from "react/jsx-runtime";
const removeLoader = 'rmPM';
export function useRemovePaymentMethod() {
  const overlayContext = useOverlayContext();
  const isVendor = useStore(selectors.user.isVendor);
  const {
    api,
    logBI
  } = useStoreActions();
  function removePaymentMethod(_ref) {
    let {
      fundingSourceId,
      vendorId,
      customerId
    } = _ref;
    const deletePaymentMethod = isVendor ? api.paymentMethod.vendorDelete(fundingSourceId, customerId) : api.paymentMethod.clientDelete(fundingSourceId, vendorId);
    return handlePromise(deletePaymentMethod);
  }
  async function removePaymentMethodWithConfirmation(_ref2) {
    let {
      fundingSourceId,
      vendorId,
      customerId,
      isCreditCard,
      last4,
      onSuccess
    } = _ref2;
    const confirmed = await overlayContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref3 => {
        let {
          dismissModal
        } = _ref3;
        return /*#__PURE__*/_jsx(ConfirmationModal, {
          title: "Remove ".concat(isCreditCard ? 'Credit card' : 'Bank account').concat(last4 ? " ending with ".concat(last4) : '', "?"),
          content: "It won't appear here anymore",
          skin: "danger",
          primaryButtonLabel: "Remove",
          primaryButtonTestid: "remove-pm-confirm",
          secondaryButtonLabel: "Cancel",
          onPrimaryButtonClick: () => dismissModal(true),
          onSecondaryButtonClick: () => dismissModal(false)
        });
      }
    });
    if (!confirmed) {
      return;
    }
    overlayContext.startLoader(removeLoader);
    const {
      success
    } = await removePaymentMethod({
      fundingSourceId,
      vendorId,
      customerId
    });
    if (!success) {
      overlayContext.showErrorToast('Failed to remove payment method', 'remove-pm-error');
      return overlayContext.stopLoader(removeLoader);
    }
    logBI(isVendor ? 10592 : 10591, {
      fundingSourceId
    });
    try {
      await onSuccess();
    } finally {
      overlayContext.stopLoader(removeLoader);
    }
  }
  return {
    removePaymentMethodWithConfirmation,
    removePaymentMethod
  };
}